module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/venue/venue.component.scss
// module id = ./src/app/routes/venue/venue.component.scss
// module chunks = 9